<template>
    <div @scroll="treeScroll" class="treeContainer">
        <el-tree :data="treeData"
                 :filter-node-method="filterNode"
                 :node-key="nodeKey"
                 :props="defaultProps"
                 @node-click="handleNodeClick"
                 ref="tree">
            <template #default="{ node, data }">
                <div class="customTreeNode">
                    <!-- 第一级固定一个图标 -->
                    <div class="customTreeNodeLeft">
                        <span :class="{
                                  'el-tree-node__expand-icon':true,
                                  'el-icon-caret-right':true,
                                  'expanded':node.expanded,
                                  'node-arrow':true}"
                              ref="nodeArrow"
                              v-if="isShowNodeIcon(node,data)" />

                        <span :class="{'el-checkbox__input':true,'is-checked':node.checked}"
                              @click.stop="checkNode(node,data)"
                              style="margin-left: 7px"
                              v-if="showCheckbox">
                           <span class="el-checkbox__inner"></span>
                        </span>

                        <span style="width: 10px;background: transparent;height: 2px;"
                              v-if="!isShowNodeIcon(node,data)" />

                        <img :src="getTreeIcon(node,data)" class="iconTree" />

                        <span :class="node.level === 1 ? 'oneLevel' : 'otherLevel'">
                            <slot :data="data" :node="node" name="label">{{ node.label }}</slot>
                        </span>
                    </div>
                    <div class="customTreeNodeRight" v-if="isShowMore(node, data)">
                        <i @click.stop="getNodeMore(node, data, $event)" class="el-icon-more"></i>
                    </div>
                </div>
            </template>
        </el-tree>
    </div>
</template>

<script>
export default {
  props: {
    queryFn: {//请求接口
      type: Function,
      // required: true,
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    nodeKey: '',
    showMoreFn: {
      type: Function,
      // required: true,
    },
    showArrowFn: {
      type: Function,
      // required: true,
    },
    filterFn: {
      type: Function,
    },
    treeIconFn: {type: Function},
    lazy: {
      type: Boolean,
      default: false
    },
    filterText: '',
    defaultProps: {
      type: Object,
      default: function () {
        return {
          children: 'children',
          label: 'label'
        }
      }
    },
    treeIcon: {
      type: String,
      default: require('@/assets/images/zzjc/ysgltz/bzdz/xzqh/tree-icon.png')
    }
  },
  data() {
    return {
      treeData: [],
      scrollTop: 0,//被卷去高度
      treeMoreOperateTop: 0,//操作高度
    }
  },
  mounted() {
    this.getTree()// 获取树形结构数据
  },
  methods: {
    checkNode(node, data) {
      node.checked = !node.checked
      this.$emit('checkChange', node, data, node.checked)
    },
    getTreeIcon(node, data) {
      let icon = this.treeIcon
      if (typeof this.treeIconFn === 'function') {
        let temp = this.treeIconFn(node, data)
        if (temp) icon = temp
      }
      return icon
    },
    tree() {
      return this.$refs.tree
    },
    // 筛选节点
    filterNode(value, data) {
      if (!value) return true
      return this.filterFn(value, data)
    },
    //tree更多icon点击
    getNodeMore(node, data, $event) {
      this.treeMoreOperateTop = $event.target.offsetTop - this.scrollTop + 44//更多操作位置
      this.$emit('getNodeMore', node, data, this.treeMoreOperateTop)
    },
    handleNodeClick(data, node) {
      this.$emit('nodeClick', data, node)
      this.$emit('moreOperateClose')
    },
    treeScroll(e) {
      this.scrollTop = e.target.scrollTop
      this.$emit('moreOperateClose')
    },
    isShowNodeIcon(node, data) {
      if (this.showArrowFn) {
        return this.showArrowFn(node, data)
      }
      return node && node.childNodes && node.childNodes.length > 0
    },
    isShowMore(node, data) {
      if (this.showMoreFn) {
        return this.showMoreFn(node, data)
      }
      return false
    },
    // 获取树形结构数据
    getTree() {
      let _t = this
      // 没有接口函数就不请求接口
      if (this.queryFn) {
        // console.log('this.queryFn', this.queryFn)
        this.queryFn().then(res => {
          if (res && res.code === 200) {
            this.treeData = res.data || []
          }
        })
      }
    },


  },

  watch: {
    filterText(val) {
      console.log('filterText', this.filterText)
      this.$refs.tree.filter(val)
    }
  },
}
</script>

<style lang="scss" scoped>
    .treeContainer {
        // padding-right: 10px;
        width: 100%;
        display: flex;
        overflow-y: auto;
        height: 100%;
        flex-flow: column;

        .customTreeNode {
            // padding: 0 10px;
            padding-right: 10px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .customTreeNodeLeft {
                display: flex;
                align-items: center;

                .oneLevel {
                    color: #616A79;
                    font-weight: bold;
                    font-size: 14px;
                    margin-left: 8px;
                }

                .otherLevel {
                    color: #616A79;
                    font-weight: bold;
                    font-size: 14px;
                    margin-left: 8px;
                }

                .iconTree {
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    margin-left: 6px;
                    // padding: 6px;
                    box-sizing: border-box;
                }
            }

            .customTreeNodeRight {
                margin-right: 10px;
            }

        }
    }


    /deep/ .el-tree-node__expand-icon {
        color: #616a79;
        /*color: transparent !important;*/
        display: none;
    }


    /deep/ .el-tree-node__expand-icon.is-leaf {
        color: transparent !important;
    }

    /deep/ .el-tree-node__content {
        height: 44px;
        padding-left: 10px !important;
    }

    /deep/ .el-tree-node.is-expanded > .el-tree-node__children {
        margin-left: 24px;
    }

    .node-arrow {
        display: initial;
        color: #616a79;
        text-align: center;
    }

</style>
